import React from 'react';
import Spinner from '@bit/xenditgroup.ui-toolkit.spinner';
import styles from './styles.module.css';
export const FullScreenLoading = () => {
    return (React.createElement("div", { className: styles['full-screen-loading'] },
        React.createElement(Spinner, { size: "lg" })));
};
